import { ReconBankPoolUploadPage } from "@/features/recon-bank/pages/ReconBankPoolUploadPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/recon-bank-upload/")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["recon_bank.create"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: ReconBankPoolUploadPage,
});
